<template>
  <div
    id="wxQrcodeLogin"
    class="impowerBox"
  >
    <div class="loginPanel normalPanel">
      <div
        class="title"
        style="font-size:18px;"
      >{{title}}</div>
      <div class="waiting panelContent">
        <div class="wrp_code">
          <canvas id="wxLoginQrCode"></canvas>
          <div
            id="wxAfter"
            style="height: 148px;width: 168px;display: none;margin: 0 auto;"
          >
            <div style="height:60px;width:61px;overflow:hidden;margin:auto;position:relative;border-radius:50%;">
              <img
                src="/static/img/wxafter.gif"
                alt=""
                style="max-width: 232px;position:absolute;left:-86px;top:-57px;"
              >
            </div>
          </div>
        </div>
        <div class="info">
          <div
            class="status status_browser js_status"
            id="wx_default_tip"
          >
            <p>{{wxDefaultTip}}</p>
            <p>{{wxDefaultTipTwo}}</p>
          </div>
          <div
            class="status status_succ js_status"
            style="display:none"
            id="wx_after_scan"
          >
            <!-- <i class="status_icon icon38_msg succ"></i> -->
            <div
              class="status_txt"
              style="padding-left:10px;"
            >
              <h4 style="font-size:18px;text-align:center">扫描成功</h4>
              <p style="font-size:18px;">请在微信中点击确认即可登录</p>
            </div>
          </div>
          <div
            class="status status_fail js_status"
            style="display:none"
            id="wx_after_cancel"
          >
            <i class="status_icon icon38_msg warn"></i>
            <div class="status_txt">
              <h4>您已取消此次登录</h4>
              <p>您可再次扫描登录，或关闭窗口</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { registWxDwz } from '@/services/short-url-service';
import { wxLogin, saveConfirmFlag, getConfirmStatus } from '@/services/weixin-service';
import { baseURL } from '@/plugins/axios';
import QRCode from 'qrcode';
import $ from 'jquery';
import eventBus from '@/plugins/event-bus';
// import { setTimeout } from 'timers';
export default {
  name: 'wxQrcodeLogin',
  props: {
    operType: {
      type: String,
      required: true
    },
    userId: {},
    title: {
      default: '微信登录'
    },
    wxDefaultTip: {
      default: '请使用微信扫描二维码登录'
    },
    wxDefaultTipTwo: {
      default: '易比得'
    },
    qrCodeConfig: {
      default: function() {
        return {
          width: 231,
          height: 231,
          margin: 0
        };
      }
    }
  },
  data() {
    return {
      iswxAfter: false,
      isWxQrcode: true,
      message: [],
      wxLoginParams: {
        confirmType: this.operType,
        confirmMsg: '确认登录易比得合规采购平台么？',
        confirmUserId: this.userId, // 微信重新绑定使用
        timeOut: '1200'
      },
      shortUrlParams: {
        operType: this.operType,
        storeKey: '',
        timeOut: '3600'
      },
      wxData: {
        openid: '',
        unionid: '',
        nickname: '',
        headimgurl: ''
      }
    };
  },
  created() {
    this.init();
  },
  methods: {
    // 保存登录参数信息
    async init() {
      try {
        let { data } = await saveConfirmFlag(this.wxLoginParams);
        if (data.returnCode === '01') {
          this.shortUrlParams.storeKey = data.storeKey;
          this.registWxDwzService();
        } else {
          this.$message.error('未知错误，请联系管理员');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    // 注册微信登录短网址
    async registWxDwzService() {
      try {
        let { data } = await registWxDwz(this.shortUrlParams);
        if (data.returnCode === '01') {
          let wxLoginUrl =
            document.location.protocol + '//' + location.host + '' + baseURL + '/api/dwz/' + data.shortUrl;
          await QRCode.toCanvas(document.getElementById('wxLoginQrCode'), wxLoginUrl, this.qrCodeConfig);
          this.getConfirmStatusService();
          this.$emit('onSuccessToCanvas');
        } else {
          this.$message.error('生成微信登录二维码失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    // 查询用户确认状态
    async getConfirmStatusService() {
      try {
        let { data } = await getConfirmStatus(this.shortUrlParams.storeKey);
        if (data.returnCode === '01') {
          if (data.confirmStatus === '1') {
            // 用户确认操作
            if (this.operType === 'REBIND') {
              location.reload(); // 重新绑定刷新当前页面
            } else if (this.operType === 'BIND') {
              this.wxData.openid = data.openid;
              this.wxData.unionid = data.unionid;
              this.wxData.nickname = data.nickname;
              this.wxData.headimgurl = data.headimgurl;
              eventBus.$emit('saveRegisterWxSuc', this.wxData);
            } else {
              this.wxLogin();
            }
          } else if (data.confirmStatus === '0') {
            // 用户取消确认
            this.transScanMsg('afterCancel');
            location.reload();
          } else if (data.confirmStatus === '2') {
            // 用户已扫描
            this.transScanMsg('afterScan');

            this.getConfirmStatusService();
          } else if (data.confirmStatus === '3') {
            // 用户未绑定
            // 重新绑定
            this.$router.push('/weixin/bindWeixin/' + this.shortUrlParams.storeKey);
          } else {
            this.getConfirmStatusService();
          }
        } else if (data.returnCode === '03') {
          this.getConfirmStatusService();
        } else {
          this.getConfirmStatusService();
        }
      } catch (error) {
        this.getConfirmStatusService();
      }
    },
    async wxLogin() {
      try {
        let { data } = await wxLogin(this.shortUrlParams.storeKey);
        if (data.returnCode === '01') {
          this.$emit('onAfterWxLogin', data);
        } else if (data.returnCode === '502') {
          location.href = '/error/502';
        } else {
          this.$message.error('微信登录失败，请联系管理员');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    transScanMsg: function(type) {
      if (type === 'afterScan') {
        $('#wx_after_scan')
          .css('display', '')
          .siblings()
          .css('display', 'none');
        $('#wxLoginQrCode').css('display', 'none');
        $('#wxAfter').css('display', 'flex');
        this.$emit('onSuccessScan');
      }
      if (type === 'afterCancel') {
        $('#wx_after_cancel')
          .css('display', '')
          .siblings()
          .css('display', 'none');
      }
    }
  }
};
</script>
<style lang="less" scoped>
#wxLoginQrCode {
  height: 233px;
}
#wxLoginQrCode img {
  margin: auto;
}

.impowerBox,
.impowerBox .status_icon,
.impowerBox .status_txt {
  display: inline-block;
  vertical-align: middle;
}

a {
  outline: 0;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0;
  font-weight: 400;
}

a img,
fieldset {
  border: 0;
}

/* body {
        font-family: "Microsoft Yahei";
        color: #fff;
        background: 0 0
    } */

.impowerBox {
  line-height: 1.6;
  position: relative;
  width: 100%;
  z-index: 1;
  text-align: center;
}

.impowerBox .title {
  text-align: center;
  font-size: 20px;
}

.impowerBox .qrcode {
  width: 280px;
  margin-top: 15px;
  border: 1px solid #e2e2e2;
}

.impowerBox .info {
  width: 280px;
  margin: 0 auto;
}

.impowerBox .status {
  padding: 7px 14px;
  text-align: left;
}

.impowerBox .status.normal {
  margin-top: 15px;
  background-color: #232323;
  border-radius: 100px;
  -moz-border-radius: 100px;
  -webkit-border-radius: 100px;
  box-shadow: inset 0 5px 10px -5px #191919, 0 1px 0 0 #444;
  -moz-box-shadow: inset 0 5px 10px -5px #191919, 0 1px 0 0 #444;
  -webkit-box-shadow: inset 0 5px 10px -5px #191919, 0 1px 0 0 #444;
}

.impowerBox .status.status_browser {
  text-align: center;
}

.impowerBox .status p {
  font-size: 13px;
}

.impowerBox .status_icon {
  margin-right: 5px;
}

.impowerBox .status_txt p {
  top: -2px;
  position: relative;
  margin: 0;
}

.impowerBox .icon38_msg {
  display: inline-block;
  width: 38px;
  height: 38px;
}

.impowerBox .icon38_msg.succ {
  // background: url(../images/icon_popup3696b4.png) 0 -46px no-repeat;
}

.impowerBox .icon38_msg.warn {
  // background: url(../images/icon_popup3696b4.png) 0 -87px no-repeat;
}
</style>
